<template>
  <div>
    <b-row class="input-row">
      <b-form-group class="input-form" :label="label_form">
        <input :type="input_type" :value="value"
          class="input-view"
         :placeholder="label_form"
        @input="updateValue($event.target.value)"/>
      </b-form-group>
    </b-row>
  </div>

</template>

<script>

export default {
  props: ["value","label_form","input_type"],
  data() {
    return {
      type:'text',
    }
  },
  methods:{
    updateValue(value) {
      this.$emit('input', value)
    }
  }
};
</script>
<style scoped>
.input-row{
  width:"100%"
}
.input-form{
  width: 100%; 
  margin-bottom: 0px
}
.input-view{
  height: 38px;
  width: 100%
}
</style>
